import { useState, useCallback, SyntheticEvent } from 'react';

export type MediaCategory = 'landscape' | 'square' | 'portrait' | 'verticalVideo' | 'none';

function getMediaCategory(naturalWidth: number, naturalHeight: number): MediaCategory {
  const ratio = naturalHeight / naturalWidth;

  if (ratio >= 1.7) return 'verticalVideo';
  if (ratio >= 0.95 && ratio <= 1.05) return 'square';
  if (naturalHeight > naturalWidth) return 'portrait';
  return 'landscape';
}

interface UseImageDimensionsResult {
  onLoad: (e: SyntheticEvent<HTMLImageElement>) => void;
  mediaCategory: MediaCategory;
  isLoaded: boolean;
}

const useImageDimensions = (): UseImageDimensionsResult => {
  const [mediaCategory, setMediaCategory] = useState<MediaCategory>('none');
  const [isLoaded, setIsLoaded] = useState(false);

  const onLoad = useCallback((e: SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    const { naturalWidth, naturalHeight } = img;
    setMediaCategory(getMediaCategory(naturalWidth, naturalHeight));
    setIsLoaded(true);
  }, []);

  return { onLoad, mediaCategory, isLoaded };
};

export default useImageDimensions;
